import React, {useMemo} from "react";
import {css, SerializedStyles, Theme} from "@emotion/react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {calculateRemSize} from "@pg-design/helpers-css";

import {ApplicationModalButtonWithHiddenPrices} from "../../../application/components/ApplicationModalButtonWithHiddenPrices";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {useShouldShowPriceByOfferConfigAndUser} from "../../../hooks/use_should_show_price_by_offer_config_and_user";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    propertyPrice?: number | null;
    propertyLink: string;
    applicationSource: number;
    applicationSourceSection: number;
    applicationButtonText?: string;
    moreInfoButtonText?: string;
    clickEvent?: () => void;
    hideApplicationButton?: boolean;
    className?: string;
    buttonSize?: IButtonSizePrimary;
    buttonStyle?: SerializedStyles;
}

export const QWActionButtons = (props: IProps) => {
    const {
        vendorId,
        offerId,
        propertyId,
        propertyPrice,
        propertyLink,
        applicationSource,
        applicationSourceSection,
        applicationButtonText,
        moreInfoButtonText,
        clickEvent,
        hideApplicationButton = false
    } = props;

    const target = useResponsiveLinkTarget();

    const handleDetailsButtonClick = () => clickEvent?.();

    const shouldShowPrice = useShouldShowPriceByOfferConfigAndUser({
        vendorId: vendorId
    });

    const buttonText = useMemo(() => {
        if (applicationButtonText) {
            return applicationButtonText;
        }

        return getLeadButtonText({
            isPriceHidden: !shouldShowPrice,
            isProperty: !!propertyId,
            propertyPrice
        });
    }, [propertyPrice, propertyId, shouldShowPrice, applicationButtonText]);

    const gtmData: IGTMEventLeadForm = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.SIDEBAR_MAP_DETAIL,
        vendorName: vendorId.toString(),
        offerName: offerId.toString()
    };

    return (
        <div css={buttonsHolder} className={props.className}>
            {!hideApplicationButton && (
                <ApplicationModalButtonWithHiddenPrices
                    source={applicationSource}
                    sourceSection={applicationSourceSection}
                    vendorId={vendorId}
                    offerId={offerId}
                    propertyId={propertyId}
                    shouldShowPrice={shouldShowPrice}
                    gtmData={gtmData}
                    render={({handleClick}) => (
                        <Button variant="filled_primary" onClick={handleClick} size={props.buttonSize || "big"} css={props.buttonStyle}>
                            {buttonText}
                        </Button>
                    )}
                />
            )}

            <Button
                as="a"
                href={propertyLink}
                onClick={handleDetailsButtonClick}
                target={target}
                variant="none_secondary"
                size={props.buttonSize}
                css={props.buttonStyle}
            >
                {moreInfoButtonText ?? "Zobacz szczegóły"}
            </Button>
        </div>
    );
};

const buttonsHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    padding-top: 3.6rem;
    gap: ${calculateRemSize(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        padding-top: 2.4rem;
        flex-direction: row;
        align-items: center;
    }
`;
import React, {useMemo} from "react";
import {css, SerializedStyles, Theme} from "@emotion/react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {calculateRemSize} from "@pg-design/helpers-css";

import {ApplicationModalButtonWithHiddenPrices} from "../../../application/components/ApplicationModalButtonWithHiddenPrices";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {useShouldShowPriceByOfferConfigAndUser} from "../../../hooks/use_should_show_price_by_offer_config_and_user";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    propertyPrice?: number | null;
    propertyLink: string;
    applicationSource: number;
    applicationSourceSection: number;
    applicationButtonText?: string;
    moreInfoButtonText?: string;
    clickEvent?: () => void;
    hideApplicationButton?: boolean;
    className?: string;
    buttonSize?: IButtonSizePrimary;
    buttonStyle?: SerializedStyles;
}

export const QWActionButtons = (props: IProps) => {
    const {
        vendorId,
        offerId,
        propertyId,
        propertyPrice,
        propertyLink,
        applicationSource,
        applicationSourceSection,
        applicationButtonText,
        moreInfoButtonText,
        clickEvent,
        hideApplicationButton = false
    } = props;

    const target = useResponsiveLinkTarget();

    const handleDetailsButtonClick = () => clickEvent?.();

    const shouldShowPrice = useShouldShowPriceByOfferConfigAndUser({
        vendorId: vendorId
    });

    const buttonText = useMemo(() => {
        if (applicationButtonText) {
            return applicationButtonText;
        }

        return getLeadButtonText({
            isPriceHidden: !shouldShowPrice,
            isProperty: !!propertyId,
            propertyPrice
        });
    }, [propertyPrice, propertyId, shouldShowPrice, applicationButtonText]);

    const gtmData: IGTMEventLeadForm = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.SIDEBAR_MAP_DETAIL,
        vendorName: vendorId.toString(),
        offerName: offerId.toString()
    };

    return (
        <div css={buttonsHolder} className={props.className}>
            {!hideApplicationButton && (
                <ApplicationModalButtonWithHiddenPrices
                    source={applicationSource}
                    sourceSection={applicationSourceSection}
                    vendorId={vendorId}
                    offerId={offerId}
                    propertyId={propertyId}
                    shouldShowPrice={shouldShowPrice}
                    gtmData={gtmData}
                    render={({handleClick}) => (
                        <Button variant="filled_primary" onClick={handleClick} size={props.buttonSize || "big"} css={props.buttonStyle}>
                            {buttonText}
                        </Button>
                    )}
                />
            )}

            <Button
                as="a"
                href={propertyLink}
                onClick={handleDetailsButtonClick}
                target={target}
                variant="none_secondary"
                size={props.buttonSize}
                css={props.buttonStyle}
            >
                {moreInfoButtonText ?? "Zobacz szczegóły"}
            </Button>
        </div>
    );
};

const buttonsHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    padding-top: 3.6rem;
    gap: ${calculateRemSize(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        padding-top: 2.4rem;
        flex-direction: row;
        align-items: center;
    }
`;
